
export const baseColors = {
  base: {
    background: { light: "#F8F8F8", dark: "#1C2128" },
    whiteBg: { light: "#FFFFFF", dark: "#1F2937" },
    secondBg: { light: "#F5F6FA", dark: "#273241" },
    icon: { light: "#64748B", dark: "#7D8EAE" },
    divider: { light: "#E2E8F0", dark: "#2A3647" },
    inputBorder: { light: "#CBD5E1", dark: "#344B73" },
    new: { light: "#FFF", dark: "#000" },
  },
  primary: {
    main: { light: "#016DD4", dark: "#2094FF" },
    dark: { light: "#0D47A1", dark: "#72B4FF" },
    soft: { light: "#E8F1FB", dark: "#183A63" },
    softHover: { light: "#DAE6F2", dark: "#214A7B" },
    lightBtnBorder: { light: "#97C3F0", dark: "#3A506B" },
    mainDimmed: {
      light: "rgba(71, 118, 164, 0.37)",
      dark: "rgba(74, 168, 255, 0.20)",
    },
  },
  secondary: {
    mainOrange: { light: "#FFC067", dark: "#F8B977" },
    darkOrange: { light: "#E38800", dark: "#FB923C" },
    textDark: { light: "#533200", dark: "#533200" },
    buttonTabHover: { light: "#F2B257", dark: "#FED7AA" },
    lightOrange: { light: "#FFF1DB", dark: "#3A2414" },
    buttonTabDimmed: {
      light: "rgba(164, 125, 71, 0.37)",
      dark: "rgba(251, 146, 60, 0.20)",
    },
    darkOrangeDimmed: {
      light: "rgba(58, 45, 25, 0.50)",
      dark: "rgba(170, 146, 108, 0.50)",
    },
  },
  accent: {
    accent: { light: "#3ABABA", dark: "#288E8E" },
  },
  text: {
    black100: { light: "#020B12", dark: "#EAF1FF" },
    grey50: { light: "#4C5A64", dark: "#A5B5D3" },
    grey25: { light: "#768692", dark: "#5D7094" },
    light100: { light: "#FFFFFF", dark: "#111C2E" },
  },
  button: {
    dimmedDark: { light: "#C8C9CC", dark: "#3E444D" },
    dimmedLight: { light: "#F9F9F9", dark: "#4B5563" },
    secondaryDimmed: {
      light: "rgba(237, 241, 246, 0.40)",
      dark: "#1F2937",
    },
    gray50Dimmed: {
      light: "rgba(82, 89, 94, 0.40)",
      dark: "rgba(165, 181, 211, 0.40)",
    },
  },
  alert: {
    error: {
      text: { light: "#C92C2C", dark: "#F58181" },
      darkBg: { light: "#D93131", dark: "#FF8282" },
      lightBg: { light: "#FFE5E5", dark: "#3D282C" },
      border: {
        light: "rgba(208, 51, 51, 0.20)",
        dark: "rgba(255, 92, 92, 0.20)",
      },
      errorDimmed: { light: "rgba(173, 100, 100, 0.40)", dark: "#7F1D1D" },
    },
    warning: {
      text: { light: "#AD5600", dark: "#FDBA74" },
      darkBg: { light: "#FD9A38", dark: "#B86B18" },
      lightBg: { light: "#FFF3DD", dark: "#3B3531" },
      border: {
        light: "rgba(180, 83, 9, 0.24)",
        dark: "rgba(251, 146, 60, 0.32)",
      },
    },
    success: {
      text: { light: "#006D67", dark: "#72C7C2" },
      darkBg: { light: "#2F817D", dark: "#1FC5BD" },
      lightBg: { light: "#E4F5F4", dark: "#283D3C" },
      border: {
        light: "rgba(47, 129, 125, 0.20)",
        dark: "rgba(46, 213, 171, 0.20)",
      },
      successDimmed: { light: "rgba(80, 115, 113, 0.40)", dark: "#065F5F" },
    },
    info: {
      text: { light: "#4238A9", dark: "#A096FF" },
      darkBg: { light: "#665CCD", dark: "#A79FF6" },
      lightBg: { light: "#EFEDFF", dark: "#2F2B52" },
      border: {
        light: "rgba(102, 92, 205, 0.20)",
        dark: "rgba(126, 116, 245, 0.30)",
      },
    },
    status2: {
      text: { light: "#0075AC", dark: "#52C7FF" },
      darkBg: { light: "#009EE9", dark: "#74B6D4" },
      lightBg: { light: "#E3F6FF", dark: "#1D4D62" },
    },
  },
} as const;

/**
 * Gradient definitions
 */
export const gradients = {
  primary:
    "background: linear-gradient(64deg, #1976D2 16.27%, #339AFF 83.73%);",
  success: "linear-gradient(135deg, #0ACC70 0%, #056839 100%)",
  warning: "linear-gradient(135deg, #E38800 0%, #BF9000 100%)",
  danger: "linear-gradient(135deg, #C62828 0%, #C61C1D 100%)",
} as const;

/**
 * Shadow definitions
 */
export const shadows = {
  main: "0 0 4px 0 rgba(0, 0, 0, 0.10)",
  sm: "0px 2px 4px rgba(0, 0, 0, 0.04)",
  md: "0px 4px 8px rgba(0, 0, 0, 0.08)",
  lg: "0px 8px 16px rgba(0, 0, 0, 0.12)",
  xl: "0px 0px 20px 0px rgba(0, 0, 0, 0.08)",
} as const;
